import "./App.css";
import Navbar from "./components/Navbar/Navbar";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Loading from "./pages/Loading";
import config from "./config.json";

import { useState, useEffect, useCallback } from "react";

function App() {
  const [fetchedLogin, setFetchedLogin] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userType, setUserType] = useState(3);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [activeSidebarData, setActiveSidebarData] = useState("");
  const [sidebarDiv, setSidebarDiv] = useState(false);
  const [sidebarReady, setSidebarReady] = useState(false);
  const [, updateState] = useState();

  const forceUpdate = useCallback(() => updateState({}), []);

  function changeUserType(value) {
    setUserType(value);
    forceUpdate();
  }

  useEffect(() => {
    (async () => {
      const response = await fetch(
        config.domainName + ":" + config.port + "/api/user",
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      );

      const content = await response.json();
      if (content["Message"] === "Success") {
        setLoggedIn(true);
        setUserType(content["Type"]);
        setUserName(content["User"]);
        // if (content["Type"] == 3) {
        //   setUserId(content("UserID"));
        // }

        setTimeout(() => {
          setFetchedLogin(true);
        }, 500);
      } else if (content["Message"] === "Unauthenticated") {
        setLoggedIn(false);
        setTimeout(() => {
          setFetchedLogin(true);
        }, 500);
      }
      //console.log(Object.keys(trainingChartData).length);
      // console.log(loopData);
    })();
  }, []);

  useEffect(() => {
    for (let i = 0; i < activeSidebarData.length; i++) {
      if (activeSidebarData[i].canToggle) {
        activeSidebarData[i].display = sidebarDiv;
        forceUpdate();
      }
    }
  }, [sidebarDiv]);

  return (
    <>
      <Router>
        {loggedIn && fetchedLogin ? (
          <Navbar
            setLoggedIn={setLoggedIn}
            userType={userType}
            userName={userName}
            setActiveSidebarData={setActiveSidebarData}
            activeSidebarData={activeSidebarData}
          />
        ) : (
          ""
        )}
        <Routes>
          <Route
            path="/login"
            exact
            element={
              !loggedIn ? (
                <Login
                  fetchedLogin={fetchedLogin}
                  setLoggedIn={setLoggedIn}
                  setUserType={changeUserType}
                  setUserName={setUserName}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/home"
            exact
            element={
              loggedIn ? (
                <Home
                  userType={userType}
                  entityID={userName}
                  sidebarDiv={sidebarDiv}
                  setSidebarDiv={setSidebarDiv}
                />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route path="/" exact element={<Navigate to="/home" />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
